import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Intro from "../../../../elements/blocks/intro";
import CustomFieldsTable from "../../../../elements/custom-fields/custom-fields-table";
export default function ActivityFields() {
    const { t } = useTranslation();
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("fields.activity-fields.activity-fields"), breadcrumbs: [
                    {
                        name: t("settings"),
                        link: "/settings",
                    },
                    {
                        name: t("fields.fields"),
                        link: "/settings/fields",
                    },
                    {
                        name: t("fields.activity-fields.activity-fields"),
                        link: "/settings/fields/activities",
                    },
                ], button: {
                    label: t("fields.activity-fields.new-activity-field"),
                    link: "/settings/fields/activities/new",
                    color: "secondary",
                    type: "new",
                } }), _jsx(CustomFieldsTable, { type: "ticket_activities" })] }));
}
